import { Search } from 'lucide-react';
import { useEffect } from 'react';
import { Kbd } from '@/components/ui/kbd';

/**
 * The top bar's search affordance and THE ⌘K binding. `onOpen` is a prop so
 * the trigger doesn't need to know which palette it opens.
 */
export function SearchTrigger({ onOpen, label = 'Search assets, shipments' }: { onOpen: () => void; label?: string }) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        onOpen();
      }
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onOpen]);

  return (
    <>
      <button
        type="button"
        onClick={onOpen}
        className="focus-ring hidden h-8 w-64 items-center gap-2 rounded-sm border border-line bg-surface px-2.5 text-sm text-ink-3 shadow-xs transition-colors hover:border-line-strong hover:text-ink-2 lg:flex"
        aria-label="Search (Command K)"
      >
        <Search className="size-3.5 shrink-0" aria-hidden="true" />
        <span className="flex-1 truncate text-left">{label}…</span>
        <Kbd>⌘K</Kbd>
      </button>
      <button
        type="button"
        onClick={onOpen}
        className="focus-ring flex size-8 items-center justify-center rounded-sm text-ink-2 transition-colors hover:bg-sidebar-accent hover:text-ink lg:hidden"
        aria-label="Search"
      >
        <Search className="size-4" aria-hidden="true" />
      </button>
    </>
  );
}
